import { xs_languageCode } from "..";
import { deepCopyBet } from './utils/deepCopyBet';
import { formatDate } from './utils/formatDate';
import { formatDateWithWeekDay } from './utils/formatDateWithWeekDay';
import { getPrematchAggs } from './utils/getPrematchAggs';
import { getSplitDesc } from './utils/getSplitDesc';
import { oddToString } from './utils/oddToString';
import { setCustomizedOdds } from './utils/setCustomizedOdds';

export function parseOutrightsData(matches, sportRef, tournamentDesc, sportDesc) {
    const sportAggs = getPrematchAggs(sportRef);
    let outrights = [];
    let forceAntepost = [];
    matches.forEach(match => {
        const desc = match.dsl[xs_languageCode]
        const [team1, team2] = getSplitDesc(desc);
        const formattedDate = formatDateWithWeekDay(match.ts);
        const parsedMatch = {
            alias: match.al,
            avv: match.a,
            categoryRef: match.ic,
            date: formattedDate.dayMonthYear,
            dateShort: formattedDate.dayMonthShort,
            dateShortYear: formattedDate.dayMonthYearShort,
            desc: match.dsl[xs_languageCode],
            id: match.bid,
            isLive: match.lv,
            openAggregata: match.oa,
            openMacrogruppo: match.om,
            pal: match.p,
            plus: match.pl,
            sport: sportRef,
            sportDesc: sportDesc,
            sportRef,
            tdesc: tournamentDesc,
            team1,
            team2,
            time: formatDate(match.ts).time,
            timestampDB: match.ts,
            tournamentDesc,
            tournamentRef: match.it
        };

        setCustomizedOdds(match.scs);

        match.scs.forEach(matchBet => {    
            //const matchBet = match.scs[0];
            // Look for the bet in the open aggregate
            let agBet = sportAggs[parsedMatch.openAggregata]?.scommesse?.find(bet => bet.id === matchBet.cs) ?? null;
            // If bet the was not found, look for it in every aggregate
            if (agBet == null) {
                const agList = Object.values(sportAggs);
                for (let i = 0; i < agList.length; i++) {
                    agBet = agList[i].scommesse.find(bet => bet.id === matchBet.cs);
                    if (agBet !== undefined) {
                        break;
                    }
                }
            }
            if (agBet !== undefined) {
                agBet = deepCopyBet(agBet);
                const odds = []
                matchBet.eqs.forEach(odd => {
                    const betData = {
                        desc: agBet.desc,
                        handicap: matchBet.h,
                        id: agBet.id,
                        isLive: parsedMatch.isLive,
                        legabile: agBet.legabile,
                        tipoHandicap: agBet.tipoHandicap
                    };
                    
                    const matchData = {
                        alias: parsedMatch.alias,
                        avv: parsedMatch.avv,
                        desc: parsedMatch.desc,
                        pal: parsedMatch.pal,
                        sportRef: parsedMatch.sport,
                        timestamp: parsedMatch.timestampDB,
                        tournamentDesc: parsedMatch.tdesc,
                        sportDesc: parsedMatch.sportDesc
                    };

                    const o = agBet.odds.find(o => o.id === odd.ce);
                    let oddDesc = odd.dsl?.[xs_languageCode] ?? o?.desc ?? null;
                    if (matchBet.dia != null && agBet.tipoHandicap !== 48) {
                        oddDesc = oddDesc? `${matchBet.dia} ${oddDesc}` : matchBet.dia;
                    }   
                    
                    if (agBet.forceAntepost) {
                        if (o != null) {
                            oddDesc = o.desc;
                            if (matchBet.dia != null){
	                            oddDesc = `${matchBet.dia} ${o.desc}`;
	                        }                            
                            
                            odds.push({
                                id: odd.ce,
                                desc: oddDesc,
                                value: oddToString(odd.q),
                                rawValue: odd.q,
                                legabile: betData.legabile,
                                betData,
                                matchData,
                                dia: matchBet.dia,
                            });
                        } else if(agBet.odds.length === 0) {
	                       	odds.push({
	                            id: odd.ce,
	                            desc: matchBet.dia != null? `${matchBet.dia} ${oddDesc}` : oddDesc,
	                            value: oddToString(odd.q),
	                            rawValue: odd.q,
	                            legabile: betData.legabile,
	                            betData,
	                            matchData,
	                            dia: matchBet.dia,
	                        });	
                        }
                    } else {
                        odds.push({
                            id: odd.ce,
                            desc: oddDesc,
                            value: oddToString(odd.q),
                            rawValue: odd.q,
                            legabile: betData.legabile,
                            betData,
                            matchData,
                            dia : matchBet.dia
                        });
                    }
                });
                agBet.odds = odds;
                agBet.handicap = matchBet.h;
                
                if (parsedMatch.scommesse !== undefined) {
                    if(parsedMatch.scommesse.find(match => (match.id === agBet.id)) && agBet.tipoHandicap === 6) {
                        let index = parsedMatch.scommesse.findIndex(match => (match.id === agBet.id))
                        parsedMatch.scommesse[index].odds.push(agBet.odds[0]);
                    } else {
                        parsedMatch.scommesse.push(agBet)
                    }
                } else {
                    parsedMatch.scommesse = [agBet];            
                }
                
                //FORCE ANTEPOST DEVE AVERE SOLO EVENTI CHE NON SONO IN OUTRIGHTS
                if (agBet.forceAntepost && !(outrights.find(match => (match.pal === parsedMatch.pal && match.avv === parsedMatch.avv)))) {
                    forceAntepost.push(parsedMatch);
                } else {
                    outrights.push(parsedMatch);
                }
            }
        });
    });

    const matchByBet = {};
    forceAntepost = forceAntepost.filter(match => {
        const bet = match.scommesse[0];
        if (matchByBet[bet.id] === undefined) {
            match.scommesse[0].odds.forEach(odd => {
                if (!odd.processed) {
                    try {
                        const desc = match.desc.split(' ( ')[0];
                        odd.desc = `${desc} - ${odd.desc}`;
                    } catch (e) {
                        odd.desc = `${match.desc} - ${odd.desc}`;
                    }
                    odd.processed = true;
                }
            });
            try {
                const desc = match.desc.split(' ( ')[1].split(' )')[0];
                match.desc = `${desc} - ${bet.desc}`;
            } catch (e) {
                match.desc = bet.desc;
            }
            bet.desc = null;
            matchByBet[bet.id] = match;
            return true;
        } else {
            const m = matchByBet[bet.id];
            match.scommesse[0].odds.forEach(odd => {
                if (!odd.processed) {
                    try {
                        const desc = match.desc.split(' ( ')[0];
                        odd.desc = `${desc} - ${odd.desc}`;
                    } catch (e) {
                        odd.desc = `${match.desc} - ${odd.desc}`;
                    }
                }
            });
            m.scommesse[0].odds.push(...match.scommesse[0].odds);
        }
        return false;
    });

    outrights.forEach(match => {
        match.scommesse.forEach(bet => {
            bet.odds.sort((a, b) => a.rawValue - b.rawValue);
        });
    });

    outrights = outrights.filter((value,index) => outrights.indexOf(value) === index);

    return outrights.concat(forceAntepost);
}